import { Situacao } from '../../pkw-data/collect/estabelecimento/situacao.enum'
import { OperadoraDeMaquina } from '../../pkw-data/collect/operadora-de-maquina.model'
import { Empresa } from '../../pkw-data/core/empresa.model'
import { RemoteFilter } from '../../pkw-data/core/util/remote-filter.interface'

export class FiltroEstabelecimento implements RemoteFilter {
    pesquisa: string
    situacao: Situacao
    operadora: OperadoraDeMaquina
    empresa: Empresa
    carente: boolean

    toFilter() {
        const filter: any = {}

        if (this.pesquisa) {
            filter.q = this.pesquisa
        }

        if (this.situacao) {
            filter.situacao = this.situacao
        }

        if (this.operadora) {
            filter.agente = {
                operadoraDeMaquina: { id: this.operadora.id }
            }
        }

        if (this.empresa) {
            filter.empresa = { empresa: { id: this.empresa.id } }
        }

        if (this.carente) {
            filter.carente = true
        }

        return filter
    }
}



// WEBPACK FOOTER //
// ./src/app/estabelecimentos/shared/filtro-estabelecimento.ts